module.exports = __webpack_public_path__ + "img/icon_info.8475c0ba.svg";